import { render, staticRenderFns } from "./anchor-info.vue?vue&type=template&id=0f7c9996&scoped=true"
import script from "./anchor-info.vue?vue&type=script&lang=js"
export * from "./anchor-info.vue?vue&type=script&lang=js"
import style0 from "./anchor-info.vue?vue&type=style&index=0&id=0f7c9996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c9996",
  null
  
)

export default component.exports